import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    margin: "-60px -40px 20px -40px",
    borderBottom: theme(props).border.solid,
}));

export const Content = styled.div(props => ({
    padding: "20px 40px",
    backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    display: "flex",
    alignItems: "baseline",
}));

export const backButton = css({
    flex: "0 0 40px",
});

export const childrenContainer = css({
    flex: "1 1 100%",
    padding: "0 20px",
});

export const actionsContainer = css({
    flex: "0 0",
});
